import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Route error caught by boundary:", error, info?.componentStack);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (this.state.hasError) {
      return (
        <div className="py-16 px-6 text-center" data-testid="error-boundary">
          <h2 className="text-lg font-semibold">Something went wrong on this page.</h2>
          <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">
            The page hit an unexpected error and was unable to render. The rest of the portal is still usable from the sidebar.
          </p>
          <button
            onClick={this.reset}
            className="mt-4 text-xs underline text-foreground hover:opacity-80"
            data-testid="error-boundary-retry"
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
